// Copyright (c) 2019 Deere & Company

import './index.scss';

import { PropTypes } from 'prop-types';
import React from 'react';
import { getModePrefix } from '../warranty-product-stucture-maintenance/services/modes';

function handleModeChange ( mode, obj ) {

    this.handleModeChange( mode, obj );

}

function handleDeleteClick ( mode, obj ) {

    this.handleDeleteClick( mode, obj );

}

function handleEditClick ( mode, id, name ) {

    this.handleEditClick( mode, id, name );

}

function handleAddClick ( mode ) {

    this.handleEditClick( mode, -1, '' );

}

function handleBaseCodeSelect ( obj ) {

    this.handleBaseCodeSelect( obj );

}

const ProductSeriesPanel = props => (
    <section className="product-series-panel">
        {( props.mode === 'SUBSERIES' || props.mode === 'BASECODE' ) && (
            <div className="series-breadcrumb">
                <span onClick={handleModeChange.bind( props, '', {} )}>
                    <span>&lt;</span>
                    {' '}
&nbsp;
                    {props.currentBaseCode[`${getModePrefix( 'SERIES' )}Name`]}
                </span>
                <span>
                    {props.productList.length === 0 && props.mode === 'SUBSERIES' && <span className="icon-trash-can" onClick={handleDeleteClick.bind( props, props.mode, props.currentBaseCode )} />}
                    <span className="icon-edit" onClick={handleEditClick.bind( props, 'SERIES', props.currentBaseCode[`${getModePrefix( 'SERIES' )}Id`], props.currentBaseCode[`${getModePrefix( 'SERIES' )}Name`] )} />
                </span>
            </div>
        )}
        {( props.mode === 'BASECODE' ) && (
            <div className="series-breadcrumb">
                <span onClick={handleModeChange.bind( props, 'SERIES', props.currentBaseCode )}>
                    <span>&lt;</span>
                    {' '}
&nbsp;
                    {props.currentBaseCode[`${getModePrefix( 'SUBSERIES' )}Name`]}
                </span>
                <span>
                    {props.productList.length === 0 && props.mode === 'BASECODE' && <span className="icon-trash-can" onClick={handleDeleteClick.bind( props, props.mode, props.currentBaseCode )} />}
                    <span className="icon-edit" onClick={handleEditClick.bind( props, 'SUBSERIES', props.currentBaseCode[`${getModePrefix( 'SUBSERIES' )}Id`], props.currentBaseCode[`${getModePrefix( 'SUBSERIES' )}Name`] )} />
                </span>

            </div>
        )}

        <header>
            {props.mode === 'SERIES' && (
                <h4>
 Product Series
                    <span className="header-secondary-text caution">Select to Edit or Delete</span>
                    {' '}

                </h4>
            )}
            {props.mode === 'SUBSERIES' && (
                <h4 className="headerAlign">
 Product Sub Series
                    <span className="header-secondary-text caution">Select to Edit or Delete</span>
                    {' '}

                </h4>
            )}
            {props.mode === 'BASECODE' && (
                <h4 className="headerAlign">
 BMC
                    <span className="header-secondary-text caution">Select to Edit or Delete</span>
                    {' '}

                </h4>
            )}
            <div className="button-list">
                <button className="primary-button" type="button" onClick={handleAddClick.bind( props, props.mode )}>
                    <span> Add New </span>
                </button>
            </div>
        </header>
        <div>
            {props.mode !== 'BASECODE' && props.productList.length > 0 && props.productList.map( product => (
                <div className="series-link" key={product[`${getModePrefix( props.mode )}Id`]}>
                    <span onClick={handleModeChange.bind( props, props.mode, product )}>
                        {product[`${getModePrefix( props.mode )}Name`]}
                    </span>
                </div>
            ) )}
            {props.mode === 'BASECODE' && props.productList.length > 0 && props.productList.map( product => (
                <div className="series-link" key={product[`${getModePrefix( props.mode )}Id`]}>
                    <span className={props.baseCodeId === product.baseCodeId ? 'higlighted' : 'series-link'} onClick={handleBaseCodeSelect.bind( props, product )}>
                        {product[`${getModePrefix( props.mode )}Name`]}
                    </span>
                </div>
            ) )}
            {!props.productList.length &&
            <div>No matching results found</div>}


        </div>
    </section>
);

ProductSeriesPanel.displayName = 'ProductSeriesPanel';
ProductSeriesPanel.propTypes = {
    baseCodeId: PropTypes.number,
    currentBaseCode: PropTypes.object,
    productList: PropTypes.array.isRequired,
    mode: PropTypes.string.isRequired,
    handleModeChange: PropTypes.func,
};

export default ProductSeriesPanel;
